import { AnimatePresence, motion } from 'motion/react';
import * as React from 'react';
import styled from 'styled-components';

import { FeedbackToast } from './FeedbackToast';
import { useFeedbackToast } from '../../../hooks/useFeedbackToast';
import { media } from '../../../media';

const Root = styled.div`
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  position: fixed;
  padding: 16px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: rgba(0, 0, 0, 0.4);
  justify-content: flex-end;
  pointer-events: none;

  @media ${media.sm} {
    justify-content: flex-start;
    align-items: flex-end;
    background-color: transparent;
    padding: 24px;
    gap: 12px;
    bottom: auto;
    left: auto;
  }
`;

const MotionRoot = motion.create(Root);

export const Feedback: React.FC = () => {
  const { feedbackToast, closeFeedbackToast: hideFeedbackToast } = useFeedbackToast();

  if (!feedbackToast) return null;

  const { id, title, operationType, onDismiss, onSuccess, warehouseId } = feedbackToast;

  if (!warehouseId) return null;

  return (
    <AnimatePresence>
      <MotionRoot initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
        <FeedbackToast
          operationType={operationType}
          key={id}
          onSuccess={(params) => {
            hideFeedbackToast(id);
            onSuccess?.(params);
          }}
          onDismiss={() => {
            hideFeedbackToast(id);
            onDismiss?.();
          }}
          title={title}
          warehouseId={warehouseId}
        />
      </MotionRoot>
    </AnimatePresence>
  );
};
